import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createFanUploadModel,updateFanUploadModel,removeFanUploadModel, removeHardFanUploadModel} from '../api/fan';
import { RootState } from '../store';


export interface ProjectState {
    newProjectResponse?:any,
    fetching: boolean,
}

const initialState: ProjectState = {
    fetching:false

}


export const createNewModel = createAsyncThunk(
    'fanUploadModal/createFanUploadModel',
    async (data: any, thunkAPI) => {
        try {
            const response = await createFanUploadModel(data); // Assuming createBladeModel is an asynchronous function
            console.log("createNewModel", response.response);
            return response.response;
        } catch (error) {
            console.log("createNewModel", error);
            return error;
        }
    }
);

export const updateModel = createAsyncThunk(
    'fanUploadModal/updateFanUploadModel',
    async (data: any) => {
        const response = await updateFanUploadModel(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);


export const removeModel = createAsyncThunk(
    'fanUploadModal/removeFanUploadModel',
    async (data: any) => {
        const response = await removeFanUploadModel(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);
export const removeHardModel = createAsyncThunk(
    'fanUploadModal/removeFanUploadModel',
    async (data: any) => {
        const response = await removeHardFanUploadModel(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);

 

export const FanUploadModalSlice = createSlice({
    name: 'fanUploadModal',
    initialState,
    reducers: {
        resetFanUploadModalStore: (state) => {
            state = initialState;
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(createNewModel.pending, (state,action) => {
                state.fetching = true;
                state.newProjectResponse = undefined
            })
            .addCase(createNewModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.newProjectResponse = action.payload
            })
            .addCase(createNewModel.rejected, (state,action) => {
                state.fetching = false;
                state.newProjectResponse = action.error.message ;
            })
    }
})


export const { resetFanUploadModalStore } = FanUploadModalSlice.actions;

export const newProjectResponse = (state: RootState) => state.fanUploadModel.newProjectResponse;

export default FanUploadModalSlice.reducer;